import { searchIndicesV1, searchIndicesV2 } from '../constants/searchIndices';
export function resolveSearchIndex(_ref) {
  let {
    environment,
    filters,
    sort,
    enableV2SearchIndex = false
  } = _ref;
  const index = enableV2SearchIndex ? searchIndicesV2 : searchIndicesV1;
  const sortIndexSuffix = sort ? sort.get('indexSuffix')({
    filters
  }) : undefined;
  return "".concat(index.getIn([environment, 'indexName'])).concat(sortIndexSuffix ? "_".concat(sortIndexSuffix) : '');
}